import { render, staticRenderFns } from "./DietPicker.vue?vue&type=template&id=5e8fff06&scoped=true&"
import script from "./DietPicker.vue?vue&type=script&lang=js&"
export * from "./DietPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8fff06",
  null
  
)

export default component.exports